module.exports = __webpack_public_path__ + "img/startup.77380c8d.png";